module.exports = __webpack_public_path__ + "media/images/avatar_female1-c6558d9845134ac7a59d252ba512ea2b.png";